import FlourishComponent from 'components/FlourishComponent';
import React from 'react';
import { Row, Col } from 'react-bootstrap';

// Gradient "blu istituzionale" del prototipo HTML (var --blu-4 → --blu-1).
// Override del default palette dei template Flourish, che è troppo poco contrastato.
const DEFAULT_COLOR_MIN = '#b8d3ec';
const DEFAULT_COLOR_MAX = '#0a3a6e';

const RegionalHeatmapChart = (
  {
    data,
    containerId,
    title = 'Map Chart',
    visualizationId = '22300629',
    height = 460,
    colorMin = DEFAULT_COLOR_MIN,
    colorMax = DEFAULT_COLOR_MAX,
  },
  ref,
) => {
  const [chartLoaded, setChartLoaded] = React.useState(false);
  if (!data) return null;

  return (
    <Row className='report-second d-flex to-break w-100 p-0 mb-0 h-100'>
      <Col className={`simple-box d-flex flex-column justify-content-center col-12 mb-0`}>
        <Row className='ml-0'>
          <h5 className='title-simple-box text-uppercase mt-1 pl-0'>
            {title}
          </h5>
        </Row>
        <FlourishComponent
          visualizationId={visualizationId}
          containerId={containerId}
          style={{ width: '100%' }}
          height={height}
          withFooter={false}
          onChartLoad={() => {
            setChartLoaded(true);
          }}
          ref={ref}
          data={{
            state: {
              map_colors: {
                sequential_palette: 'Custom',
                sequential_custom_min: colorMin,
                sequential_custom_max: colorMax,
                sequential_reverse: false,
              },
            },
            bindings: {
              points: {
                metadata: [],
                value: [],
              },
              regions: {
                id: 0,
                metadata: [1],
                name: 2,
                value: [3],
              },
              regions_geometry: {
                geometry: 0,
                id: [1, 2],
              },
            },
            data: {
              regions: data || [],
            },
            metadata: {
              points: {},
              regions: {
                0: {
                  type_id: 'string$arbitrary_string',
                  type: 'string',
                  output_format_id: 'string$arbitrary_string',
                },
                1: {
                  type_id: 'number$comma_point',
                  type: 'number',
                  output_format_id: 'number$point_comma',
                },
                2: {
                  type_id: 'string$arbitrary_string',
                  type: 'string',
                  output_format_id: 'string$arbitrary_string',
                },
                3: {
                  type_id: 'number$comma_point',
                  type: 'number',
                  output_format_id: 'number$point_comma',
                },
              },
              regions_geometry: {
                0: {
                  type_id: 'string$arbitrary_string',
                  type: 'string',
                  output_format_id: 'string$arbitrary_string',
                },
                1: {
                  type_id: 'string$arbitrary_string',
                  type: 'string',
                  output_format_id: 'string$arbitrary_string',
                },
                2: {
                  type_id: 'string$arbitrary_string',
                  type: 'string',
                  output_format_id: 'string$arbitrary_string',
                },
              },
            },
          }}
          // dataToRespond={[...extractedData.flat()]}
        />
      </Col>
    </Row>
  );
};

export default RegionalHeatmapChart;
